import {
  DEPOSIT_SEARCH_COUNTRY_REQUEST,
  DEPOSIT_SEARCH_PUBLICATION_REQUEST,
  DEPOSIT_SEARCH_REQUEST,
  DEPOSIT_SEARCH_WATER_REQUEST,
  DEPOSIT_SEARCH_CLEAR,
  DEPOSIT_SEARCH_CLEAR_REDIRECT,
  DEPOSIT_SEARCH_GEOAGE_REQUEST, DEPOSIT_DATA_SORT,
  DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST,
  DEPOSIT_DATA_TOGGLE_COLUMN,
  DEPOSIT_DATA_CLEAR,
  DEPOSIT_DATA_BULK_EDIT_REQUEST,
  DEPOSIT_DATA_CANCEL_EDIT,
  DEPOSIT_DATA_EDIT,
  DEPOSIT_DATA_SAVE_CANCEL_CONFIRMATION,
  DEPOSIT_DATA_SAVE_OPEN_CONFIRMATION,
} from './depositSearchReducer';

export const searchDeposits = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: DEPOSIT_SEARCH_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});
export const clearSearch = () => ({ type: DEPOSIT_SEARCH_CLEAR });
export const clearDepositData = () => ({ type: DEPOSIT_DATA_CLEAR });
export const clearRedirect = () => ({ type: DEPOSIT_SEARCH_CLEAR_REDIRECT });

export const getCountries = () => ({ type: DEPOSIT_SEARCH_COUNTRY_REQUEST });
export const getPublications = () => ({ type: DEPOSIT_SEARCH_PUBLICATION_REQUEST });
export const getBodiesOfWater = () => ({ type: DEPOSIT_SEARCH_WATER_REQUEST });
export const getGeologicAges = () => ({ type: DEPOSIT_SEARCH_GEOAGE_REQUEST });

export const deleteDeposit = ({ id }) => ({ type: DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST, id });
export const sortData = sort => ({ type: DEPOSIT_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: DEPOSIT_DATA_TOGGLE_COLUMN, visibleColumns });

export const bulkEditDeposits = ({ data }) => ({ type: DEPOSIT_DATA_BULK_EDIT_REQUEST, data });
export const openEditConfirmation = ({ formData, initialFormData }) => ({ type: DEPOSIT_DATA_SAVE_OPEN_CONFIRMATION, formData, initialFormData });
export const cancelEditConfirmation = () => ({ type: DEPOSIT_DATA_SAVE_CANCEL_CONFIRMATION });
export const startEdit = ({ initialValues }) => ({ type: DEPOSIT_DATA_EDIT, initialValues });
export const cancelEdit = () => ({ type: DEPOSIT_DATA_CANCEL_EDIT });
